import React from "react";
import { fileUrl } from "@/lib/files";

export const CollectorAvatar = ({ name, photo, size = "w-7 h-7" }) => (
  <span className={`${size} rounded-full bg-[#2D6A4F]/15 overflow-hidden inline-flex items-center justify-center text-[11px] font-semibold text-[#1E3F33] shrink-0`}>
    {photo ? <img src={fileUrl(photo)} alt="" className="w-full h-full object-cover" /> : (name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()}
  </span>
);
